import { Trans, useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { ROUTES } from '@/common/constants/routes';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { LearningCentreModal } from '@/web/components/LearningCentreModal/LearningCentreModal';
import {
  Button,
  IconCreditCard,
  IconUtensils,
} from '@coverflex-tech/hypernova';
import css from './MealVoucherLearningCenter.module.css';

export interface ILearningCenterProps {
  onClose: () => void;
}

export const MealVoucherLearningCenter = ({
  onClose,
}: ILearningCenterProps) => {
  const { t } = useTranslation();
  const {
    features: { FF_DISCOUNTS },
  } = useGetFeatures();
  return (
    <LearningCentreModal
      icon={<IconUtensils className={css.icon} />}
      onClose={onClose}
      steps={[
        <div className={css.container} key="learning_centre_step_1">
          <div className={css.column}>
            <BodyText bold className={css.title}>
              {t('dashboard.meal_voucher.learning_centre.how_title')}
            </BodyText>
            <BodyText>
              <Trans
                i18nKey={'dashboard.meal_voucher.learning_centre.how_content'}
              />
            </BodyText>
          </div>
          <div className={css.column}>
            <BodyText bold className={css.title}>
              <IconCreditCard width={24} height={24} />
              {t('dashboard.meal_voucher.learning_centre.card_title')}
            </BodyText>
            <BodyText>
              <Trans
                i18nKey={`dashboard.meal_voucher.learning_centre.card_content${
                  FF_DISCOUNTS ? '_with_discounts' : ''
                }`}
              />
            </BodyText>
            <RouterLink href={ROUTES.MEAL_NETWORK} className={css.link}>
              <Button variant="tertiary" presentational size="sm">
                {t('dashboard.meal_voucher.learning_centre.link')}
              </Button>
            </RouterLink>
          </div>
        </div>,
      ]}
      title={t('dashboard.meal_voucher.title')}
      subtitle={t('dashboard.meal_voucher.learning_centre.description')}
    />
  );
};
